'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertNeutral = require('./components/AlertNeutral.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertNeutral).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/neutral/index.js
// module id = 878
// module chunks = 0 3